const setting = {
  passwordTitle: "비밀번호",
  changePasswordBtn: "비밀번호 변경하기",
  changePasswordTips:
    "비밀번호를 잊어버렸거나 비밀번호를 변경하고 싶은 경우 여기에서 변경할 수 있습니다. 등록된 전자 메일 주소로 인증 코드를 보내 본인 확인을 위해 인증 코드를 전송한 다음 계정 비밀번호를 재설정할 수 있습니다.",
  feedbackTitle: "피드백",
  feedbackBtn: "피드백 제출하기",
  feedbackTips:
    "고객님께 더 나은 서비스를 제공하기 위해 여기에 고객님의 문제점을 기술하여 피드백을 주시면 고객 서비스 팀에서 빠른 시일 내에 연락드리겠습니다.",
  appearanceTitle: "모양 표시",
  appearanceBtn: "모양 표시 변경하기",
  appearanceTips: "두 가지 모양 모드를 선택하므로 취향에 따라 다크 모드와 라이트 모드를 전환할 수 있습니다.",
  changePassWordModalTitle: "비밀번호 변경하기",
  changePassWordSameErrorTips: "입력한 새 비밀번호가 이전 비밀번호와 동일합니다. 다른 비밀번호 입력하십시오.",
  changePasswordCurrentErrorTips: "비밀번호가 올바르지 않습니다. 다시 시도하십시오.",
  currentPasswordLabel: "현재 비밀번호",
  newPasswordLabel: "새 비밀번호",
  retypePasswordLabel: "새 비밀번호 다시 입력하세요.",
  changePasswordSuccessTips: "비밀번호가 성공적으로 변경되었습니다.",
  changePasswordComfirmDiffErrorTips: "두 번에 동일한 비밀번호를 입력해주세요",
  forgotPassword: "비밀번호를 잊으셨습니까?",
  feedbackModalSubtitle: "저희에게 연락주셔서 제품에 대한 의견을 말씀해 주셔서 감사합니다!",
  feedBackModalProductQuestion: "이 제품을 사용하면 어떤 문제를 해결하고 싶습니까?",
  feedBackModalProductTypeSug: "제안",
  feedBackModalProductTypeMem: "회원 서비스 관련 질문",
  feedBackModalProductTypeFun: "함수 조회",
  feedBackModalProductTypeReq: "제품 요구 사항",
  feedBackModalProductTypeBug: "제품 버그에 대한 피드백",
  feedBackModalProductTypeIss: "성능 문제",
  feedBackModalProductTypeRL: "등록 및 로그인 관련 질문",
  feedBackModalProductTypeRef: "환불 서비스",
  feedBackModalProductTypeOth: "다른",
  feedBackModalProductSelectQuestion: "이 제품을 사용하면 어떤 문제를 해결하고 싶습니까?",
  feedBackModalProductContQuestion: "제품을 사용할 때 어떤 문제가 발생했나요?",
  feedBackModalAddImageBtn: "파일 추가",
  feedBackModalTips: "추가 정보:",
  feedBackModalTipsCont: "글로벌 고객 서비스의 시차로 인해 근무일 기준 48시간 이내에 회신 드리겠습니다.",
  feedBackSuccessTips: "성공적으로 전송했습니다.",
  feedBackSuccessSubTips: "최대한 빨리 문제를 해결하겠습니다.",
  feedBackFailedTips: "전송 실패했습니다.",
  feedBackFailedSubTips: "네트워크 연결이 작동하는지 확인하고 다시 제출하십시오.",
  appearanceLightMode: "라이트 모드",
  appearanceDarkMode: "다크 모드",
  promotionModalTitle: "프로모션",
  promoItem: "프로모션 품목",
  promoCode: "프로모션 코드",
  discount: "할인",
  applyBtn: "적용하기",
  applyPromotionErrorTips: "할인 코드가 잘못되었습니다.",
};

export default setting;
